import { Input } from '@mgmresorts/wcl-lab';
import React, { useCallback, useEffect, useRef } from 'react';

import { BindInput } from '../../../../hooks/useInput';

type BirthdayInputProps = BindInput & {
  id: string;
  testId: string;
  label: string;
  hint?: string;
  error?: boolean;
  disabled?: boolean;
  className?: string;
};

export function BirthdayInput(props: BirthdayInputProps) {
  const birthdayRef: React.RefObject<HTMLInputElement> = useRef(null);

  const repositionCaret = useCallback(() => {
    if (birthdayRef.current && birthdayRef.current.selectionEnd) {
      const cleanLength = props.value.replace(/M/g, '').replace(/D/g, '').replace(/Y/g, '').replace(/\//g, '').length;
      const isFirstSlash = cleanLength >= 2;
      const isSecondSlash = cleanLength >= 4;

      if (isSecondSlash) {
        birthdayRef.current.selectionEnd = cleanLength + 2;
        return;
      }
      if (isFirstSlash) {
        birthdayRef.current.selectionEnd = cleanLength + 1;
        return;
      }
      birthdayRef.current.selectionEnd = cleanLength;
    }
  }, [props.value]);

  useEffect(() => {
    repositionCaret();
  }, [repositionCaret]);

  return <Input ref={birthdayRef} {...props} />;
}
